import {Pipe, PipeTransform} from "@angular/core";
import {IFormField} from "../../../shared/components/form-field-wrapper/form-field-wrapper.component";

@Pipe({
    name: "questionType",
    standalone: false
})
export class QuestionTypePipe implements PipeTransform {
  transform = (
    questions: IFormField[],
    displayFieldTypes?: string[]
  ): {}[] =>
    // don't filter when list is empty or when 'all' is selected
    !displayFieldTypes || displayFieldTypes.length < 1 || displayFieldTypes.indexOf("all") !== -1
      ? questions
      : questions.filter(q => displayFieldTypes.some(displayFieldType => this.getQuestionType(displayFieldType, q)));

  getQuestionType = (displayFieldType, q) => {
    if (!displayFieldType || !q.displayFieldType || !q.dataType) return false;
    if (displayFieldType === 'number')
      return q.displayFieldType === 'text' && (q.dataType.toLowerCase() === 'integer' || q.dataType.toLowerCase() === 'float');
    else if (displayFieldType === 'text')
      return q.displayFieldType === 'text' && q.dataType.toLowerCase() === 'string';
    else
      return q.displayFieldType.toLowerCase() === displayFieldType.toLowerCase()
  };
}
